import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, useIonLoading } from '@ionic/react';
import React, { useState, useEffect } from 'react';
import { IonGrid, IonRow, IonCol } from '@ionic/react';
import { fingerPrint, personCircle, eye, eyeOff, logoGoogle } from "ionicons/icons";
import { useHistory, useLocation } from "react-router-dom";
import { useParams } from "react-router";
import { IonItem, IonLabel, IonInput, IonButton, IonIcon, IonAlert } from '@ionic/react';
import axiosCall from '../data/axios';
import { Preferences } from '@capacitor/preferences';
import { PushNotifications } from '@capacitor/push-notifications';
import { Capacitor } from '@capacitor/core';
import { NativeBiometric } from "capacitor-native-biometric";

import AuthContext from "../UserContext";

function validateEmail(email: string) {
    const re = /^((?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\]))$/;
    return re.test(String(email).toLowerCase());
}

const Auth: React.FC = () => {
    const history = useHistory();
    const location = useLocation(); 

    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");
    const [rePassword, setRePassword] = useState<string>("");
    const [name, setName] = useState<string>();
    const [iserror, setIserror] = useState<boolean>(false);
    const [message, setMessage] = useState<string>("");
    const [mode, setMode] = useState<string>(window.location.pathname);
    const [pushRegToken, setPushRegToken] = useState('');
    const [bmEmail, setBmEmail] = useState<any>();
	const [triggerLogin, setTriggerLogin] = useState<boolean>(false);
    const { code }: any = useParams();

    // Get query params from the URL
    const queryParams = new URLSearchParams(location.search);
    const access = queryParams.get('access');
    const refresh = queryParams.get('refresh');

    const { authValues, fetchUser, logout } = React.useContext(AuthContext);

    const spinnerOptions = {
		message: 'Please wait...',
		animated: true,
		cssClass: 'drukre-loading',
		showBackdrop: true
	};
	const [spinnerPresent, spinnerDismiss] = useIonLoading();

    if (mode.indexOf('/verify') > -1) {

		if (code) {
			const veriData = {};
			axiosCall("/auth/user/verify-email/"+code, 'post', veriData)
				.then((res: any) => {
					spinnerDismiss();
					history.push("/login");
				})
				.catch((error: any) => {
					setMessage("Please try login.");
					setIserror(true);
					spinnerDismiss();
				});
		}
	} else if (mode.indexOf('/social-auth-callback') > -1) {
        spinnerDismiss();

        if (!access) {

            axiosCall("/auth/user/google-callback?code="+code, 'get', { code: code })
                .then((res: any) => {       
                    console.log("Social auth callback success");
                    console.log(res.data);
                    Preferences.set({
                        key: 'accessToken',
                        value: res.data.access,
                    });

                    Preferences.set({
                        key: 'refreshToken',
                        value: res.data.refresh,
                    });

                    if (Capacitor.isNativePlatform()) {
                        /*
                        Preferences.set({
                            key: 'userEmail',
                            value: ''
                        });
                        Preferences.set({
                            key: 'userPassword',
                            value: ''
                        });
                        */
                    }

                    window.open("/agentmap", "_self");
                });
        } else {

            if(access && refresh) {
                Preferences.set({
                    key: 'accessToken',
                    value: access ?? ''
                });

                Preferences.set({
                    key: 'refreshToken',
                    value: refresh ?? ''
                });

                if (Capacitor.isNativePlatform()) {
                    /*
                    Preferences.set({
                        key: 'userEmail',
                        value: ''
                    });
                    Preferences.set({
                        key: 'userPassword',
                        value: ''
                    });
                    */
                }

                window.open("/agentmap", "_self");
            }
        }

    }
    else if (authValues.authenticated)
		history.goBack();

    useEffect(() => {
		setMode(window.location.pathname);
	}, [window.location.pathname]);

	function clickMode(newMode: string) {
		//setMode(newMode);
		history.push(newMode);
	};

    if (authValues.authenticated)
        history.goBack();

    useEffect(() => {
		const registerPush = async () => {
			if (Capacitor.isNativePlatform()) {
				const pushTokenData = {
					"captchaToken": null,
					"captchaAction": '',
					"device_fcm_token": pushRegToken
				}
                /*
				await getCaptchaToken('SIGNUP').then((token: any) => { // Here wait token generated
					if (token) {
						pushTokenData.captchaToken = token;
						pushTokenData.captchaAction = 'SIGNUP';
					}
				});
                */
				await PushNotifications.addListener('registration', token => {
					console.log('Push registration success, token: ' + token.value);
					setPushRegToken(token.value);
					
					pushTokenData.device_fcm_token = token.value;
					axiosCall("/api/saveDeviceToken", 'post', pushTokenData, true)
						.then((res: any) => {
							console.log("Device token saved");
						})
						.catch((error: any) => {
							console.error("Device token save failed: " + error.message);
						});
				});

				await PushNotifications.addListener('registrationError', error => {
					console.error('Push registration error: ', error);
					throw error;
				});

				let permStatus = await PushNotifications.checkPermissions();

				if (permStatus.receive === 'prompt') {
					permStatus = await PushNotifications.requestPermissions();
				}

				if (permStatus.receive !== 'granted') {
					throw new Error('User denied permissions!');
				}

				await PushNotifications.register();
			}
		};

		registerPush();
	}, []);

    if (Capacitor.isNativePlatform()) {
		Preferences.get({ key: 'userEmail' }).then((emailData) => {
			if (emailData.value != null)
				setBmEmail(emailData.value);
		});
	}

	const handleBiometricAuth = async () => {
		try {
			console.log('BiometricAuth.isAvailable called');
			const bmIsAvailable = await NativeBiometric.isAvailable();
			if(!bmIsAvailable.isAvailable){
				console.log('BiometricAuth.isAvailable not available');
				setMessage('Biometric authentication not available on your device');
				setIserror(true);
				return
			}
			//const isFaceID = bmIsAvailable.biometryType == BiometryType.FACE_ID;
			console.log('BiometricAuth.verify called');
			const result = await NativeBiometric.verifyIdentity({
				reason: "For easy log in",
				title: "Log In",
				subtitle: "Biometric Authentication",
				description: "Facial or Fingerprint Authentication",
			})
			.then(() => true)
			.catch(() => false);

			if (result) {
				console.log('BiometricAuth.verify result:', result);
				if (bmEmail != null)
					setEmail(bmEmail);
				let userPassword = Preferences.get({ key: 'userPassword' });
				// Await the promise resolution
				let userPasswordData = await userPassword;
				if (userPasswordData.value != null)
					setPassword(userPasswordData.value);
				// Trigger login after setting email and password
                setTriggerLogin(true);
			} else {
				console.log('BiometricAuth.verify failed');
				setMessage('Authentication failed!');
				setIserror(true);
			}
		} catch (error: any) {
			setMessage('Error during authentication: ' + error.message);
			setIserror(true);
		}
	};

	useEffect(() => {
        if (triggerLogin && email && password) {
            handleLogin();
            setTriggerLogin(false); // Reset the trigger
        }
    }, [triggerLogin]);

    const handleLogin = async () => {
        if (!email) {
            setMessage("Please enter a valid email");
            setIserror(true);
            return;
        }
        if (validateEmail(email) === false) {
            setMessage("Your email is invalid");
            setIserror(true);
            return;
        }

        if (!password || password.length < 6) {
            setMessage("Please enter your password");
            setIserror(true);
            return;
        }

        const loginData = {
            "email": email.toLowerCase(),
            "password": password
        }

        spinnerPresent(spinnerOptions);

        axiosCall("/api/token/", 'post', loginData)
            .then((res: any) => {
                spinnerDismiss();
                Preferences.set({
                    key: 'accessToken',
                    value: res.data.access,
                });

                Preferences.set({
                    key: 'refreshToken',
                    value: res.data.refresh,
                });
                if (Capacitor.isNativePlatform()) {
					Preferences.set({
						key: 'userEmail',
						value: email
					});
					Preferences.set({
						key: 'userPassword',
						value: password
					});
				}
                //fetchUser();
                //history.push("/agentmap");
                //history.goBack();
                window.open("/agentmap", "_self");
            })
            .catch((error: any) => {
                setMessage("Failed to login. Please check your credentials and try again. "+error.message);
                setIserror(true);
                spinnerDismiss();
            });

    };

    const handleRegistration = () => {
        if (!email) {
            setMessage("Please enter a valid email");
            setIserror(true);
            return;
        }
        if (validateEmail(email) === false) {
            setMessage("Your email is invalid");
            setIserror(true);
            return;
        }

        if (!password || password.length < 6) {
            setMessage("Please enter your password. Make sure it is not too short.");
            setIserror(true);
            return;
        }

        if (password !== rePassword) {
            setMessage("Passwords do not match. Please re-enter your password.");
            setIserror(true);
            return;
        }

        const regData = {
            "name": name,
            "email": email,
            "password": password,
            "re_password": password,
            "is_realtor": "True"
        }

        spinnerPresent(spinnerOptions);

        const headers = {
            'Content-Type': 'application/json'
        }

        axiosCall("/auth/user/register", 'post', regData)
            .then((res: any) => {
                spinnerDismiss();
                history.push("/login");
            })
            .catch((error: any) => {
                setMessage("Unable to create account. " + error.message);
                setIserror(true);
                spinnerDismiss();
            });

    };

    const handlePasswordReset = () => {

        if (!email) {
			setMessage("Please enter a valid email");
			setIserror(true);
			return;
		}

		if (validateEmail(email) === false) {
			setMessage("Your email is invalid");
			setIserror(true);
			return;
		}
		const resetData = {
			"email": email,
			"captchaToken": null,
			"captchaAction": ''
		}

        /*
		await getCaptchaToken('RESET').then((token: any) => { // Here wait token generated
			if (token) {
				resetData.captchaToken = token;
				resetData.captchaAction = 'RESET';
			}
		});
        */

		spinnerPresent(spinnerOptions);

		const headers = {
			'Content-Type': 'application/json'
		}

		axiosCall("/auth/user/password-reset-request", 'post', resetData)
			.then((res: any) => {
				spinnerDismiss();
				setMessage("Password Reset Email sent. Please check your email.");
			})
			.catch((error: any) => {
				setMessage("Reset request failed. " + error.message);
				setIserror(true);
				spinnerDismiss();
			});

    };

    const [showPassword, setShowPassword] = useState(false);

    const handleGoogleLogin = () => {
        axiosCall("/auth/user/google-auth-url", 'get', {})
            .then((res: any) => {
                
                window.open(res.data.auth_url, "_self");

                Preferences.set({
                    key: 'accessToken',
                    value: res.data.access,
                });

                Preferences.set({
                    key: 'refreshToken',
                    value: res.data.refresh,
                });
            })
            .catch((error: any) => {
                console.log("Google login failed: " + error.message);
            });
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle> </IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding ion-text-center">
                {Capacitor.isNativePlatform() && (
                    <div style={{
                        height: 'env(safe-area-inset-top)',
                        backgroundColor: 'rgba(107, 105, 105, 0)',
                        minHeight: '30px' // Fallback for older devices
                    }}></div>
                )}
                <IonGrid>
                    <IonRow>
                        {mode == '/register' ?
                            <IonCol size-md="6" offset-md="3">
                                <IonRow>
                                    <IonCol>
                                        {/*
                    <IonAlert
                        isOpen={iserror}
                        onDidDismiss={() => setIserror(false)}
                        cssClass="my-custom-class"
                        header={"Error!"}
                        message={message}
                        buttons={["Dismiss"]}
                    />
                    */}
                                        <IonLabel color="danger">{message}</IonLabel>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol>
                                        <IonIcon
                                            color="drukre"
                                            style={{ fontSize: "70px" }}
                                            icon={personCircle}
                                        />
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol>
                                        <IonItem>
                                            <IonInput label="Name" type="text" onIonInput={(e) => setName(e.detail.value!)}>
                                            </IonInput>
                                        </IonItem>
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol>
                                        <IonItem>
                                            <IonInput label="Mobile Number" type="number">
                                            </IonInput>
                                        </IonItem>
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol>
                                        <IonItem>
                                            <IonInput label="Email" type="email" value={email} onIonInput={(e) => setEmail(e.detail.value!)} >
                                            </IonInput>
                                        </IonItem>
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol>
                                        <IonItem>
                                            <IonInput type="password" label="Password" value={password} onIonInput={(e) => setPassword(e.detail.value!)} >
                                            </IonInput>
                                        </IonItem>
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol>
                                        <IonItem>
                                            <IonInput type="password" label="Re Enter Password" value={rePassword} onIonInput={(e) => setRePassword(e.detail.value!)} >
                                            </IonInput>
                                        </IonItem>
                                    </IonCol>
                                </IonRow>

                                <IonRow>
                                    <IonCol>
                                        <p style={{ fontSize: "small" }}>
                                            By clicking REGISTER you agree to our <span onClick={() => history.push("/terms-and-conditions")}>Terms and Conditions</span>
                                        </p>
                                        <IonButton color="drukre" expand="block" onClick={handleRegistration}>Register</IonButton>
                                        <p style={{ fontSize: "medium" }}>
                                            Already have an account? <a onClick={() => clickMode('/login')}>Sign In!</a>
                                        </p>

                                    </IonCol>
                                </IonRow>
                            </IonCol>
                            : mode == '/password-reset-request' ?
                                <IonCol size-md="6" offset-md="3">
                                    <IonRow>
                                        <IonCol>
                                            <IonLabel color="danger">{message}</IonLabel>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonIcon
                                                color="drukre"
                                                style={{ fontSize: "70px" }}
                                                icon={personCircle}
                                            />
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonItem>
                                                <IonInput type="email" label="Email" value={email} onIonInput={(e) => setEmail(e.detail.value!)}>
                                                </IonInput>
                                            </IonItem>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonButton color="drukre" expand="block" onClick={handlePasswordReset}>Reset Password</IonButton>
                                            <p style={{ fontSize: "medium" }}>
                                                Back to <a onClick={() => clickMode('/login')}>Sign In!</a>
                                            </p>
                                        </IonCol>
                                    </IonRow>
                                </IonCol>
                                :
                                <IonCol size-md="6" offset-md="3">
                                    <IonRow>
                                        <IonCol>
                                            <IonLabel color="danger">{message}</IonLabel>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonIcon
                                                color="drukre"
                                                style={{ fontSize: "70px" }}
                                                icon={personCircle}
                                            />
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <IonItem>
                                                <IonInput label="Email" type="email" value={email} onIonInput={(e) => setEmail(e.detail.value!)}>
                                                </IonInput>
                                            </IonItem>
                                        </IonCol>
                                    </IonRow>

                                    <IonRow>
                                        <IonCol>
                                            <IonItem>
                                            <IonInput
                                                    label="Password"
                                                    type={showPassword ? "text" : "password"}
                                                    value={password}
                                                    onIonInput={(e) => setPassword(e.detail.value!)}
                                                />
                                                <IonIcon
                                                    slot="end"
                                                    icon={showPassword ? eyeOff : eye}
                                                    onClick={() => setShowPassword(!showPassword)}
                                                />
                                            </IonItem>
                                        </IonCol>
                                    </IonRow>
                                    <IonRow>
                                        <IonCol>
                                            <p style={{ fontSize: "small" }}>
                                                By clicking LOGIN you agree to our <span onClick={() => history.push("/terms-and-conditions")}>Terms and Conditions</span>
                                            </p>
                                            <IonButton color="drukre" expand="block" onClick={handleLogin}>Login</IonButton>
                                            <p style={{ fontSize: "medium" }}>
                                                Don't have an account? <a onClick={() => clickMode('/register')}>Sign up!</a> |
                                                Forgot Password? <a onClick={() => clickMode('/password-reset-request')}>Reset!</a>
                                            </p>
                                            {!Capacitor.isNativePlatform() &&
                                                <IonButton fill="outline" onClick={() => handleGoogleLogin()}>
                                                    <IonIcon icon={logoGoogle} color="secondary" className="ion-padding-end"></IonIcon>
                                                    Continue with Google
                                                </IonButton>
                                            }
                                            {Capacitor.isNativePlatform() && bmEmail != null &&
                                                <IonButton color="drukre" onClick={handleBiometricAuth}><IonIcon icon={fingerPrint}></IonIcon>Facial/Fingerprint Login</IonButton>
                                            }

                                        </IonCol>
                                    </IonRow>
                                </IonCol>
                        }
                    </IonRow>
                    <IonRow>
						<IonCol>
							<p style={{ fontSize: "small" }}>
								This site is protected by reCAPTCHA and the Google
								<a href="https://policies.google.com/privacy" target="_blank"> Privacy Policy</a> and
								<a href="https://policies.google.com/terms" target="_blank"> Terms of Service</a> apply.
							</p>
						</IonCol>
					</IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
};

export default Auth;